<template>
  <TabBar gap="desktop:gap-4" data-testid="visitor-tabs">
    <TabBarItem v-model="tabModel" selected-value="all" px-class="px-6 desktop:px-8" data-testid="visitor-tab-all">
      {{ $t('VisitorProfiles.tabs.all') }}
    </TabBarItem>
    <TabBarItem v-model="tabModel" selected-value="new" px-class="px-6 desktop:px-8" data-testid="visitor-tab-new">
      {{ $t('VisitorProfiles.tabs.new') }}
      <span
        v-if="statusCounts?.find((status) => status.status === VisitorProfileStatusEnum.Unprocessed)?.count"
        class="rounded-lg border-2 border-subtle bg-surface-elevation-2 px-0.5 text-label-s-bold text-subtle"
      >
        {{ statusCounts?.find((status) => status.status === VisitorProfileStatusEnum.Unprocessed)?.count }}
      </span>
    </TabBarItem>
    <TabBarItem v-model="tabModel" selected-value="interesting" px-class="px-6 desktop:px-8" data-testid="visitor-tab-interesting">
      {{ $t('VisitorProfiles.tabs.interesting') }}
      <span
        v-if="statusCounts?.find((status) => status.status === VisitorProfileStatusEnum.Interesting)?.count"
        class="rounded-lg border-2 border-subtle bg-surface-elevation-2 px-0.5 text-label-s-bold text-subtle"
      >
        {{ statusCounts?.find((status) => status.status === VisitorProfileStatusEnum.Interesting)?.count }}
      </span>
    </TabBarItem>
    <TabBarItem v-model="tabModel" selected-value="contacted" px-class="px-6 desktop:px-8" data-testid="visitor-tab-contacted">
      {{ $t('VisitorProfiles.tabs.contacted') }}
      <span
        v-if="statusCounts?.find((status) => status.status === VisitorProfileStatusEnum.Contacted)?.count"
        class="rounded-lg border-2 border-subtle bg-surface-elevation-2 px-0.5 text-label-s-bold text-subtle"
      >
        {{ statusCounts?.find((status) => status.status === VisitorProfileStatusEnum.Contacted)?.count }}
      </span>
    </TabBarItem>
    <TabBarItem v-model="tabModel" selected-value="not_relevant" px-class="px-6 desktop:px-8" data-testid="visitor-tab-irrelevant">
      {{ $t('VisitorProfiles.tabs.not_relevant') }}
      <span
        v-if="statusCounts?.find((status) => status.status === VisitorProfileStatusEnum.NotRelevant)?.count"
        class="rounded-lg border-2 border-subtle bg-surface-elevation-2 px-0.5 text-label-s-bold text-subtle"
      >
        {{ statusCounts?.find((status) => status.status === VisitorProfileStatusEnum.NotRelevant)?.count }}
      </span>
    </TabBarItem>
  </TabBar>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { VisitorProfileStatusEnum } from '@/gql/myomr'
import { TabBar, TabBarItem } from '@/ui/Tabs'
const props = defineProps<{
  selectedTab: 'all' | 'new' | 'interesting' | 'contacted' | 'not_relevant'
  statusCounts?: {
    status: VisitorProfileStatusEnum
    count: number
  }[]
}>()

const emit = defineEmits<{
  'update:selected-tab': [tab: string]
}>()

const tabModel = computed({
  get: () => props.selectedTab,
  set: (value) => emit('update:selected-tab', value),
})
</script>
